import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Lightbox from 'react-image-lightbox';

class PhotoGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lightbox: {
        open: false,
        index: undefined,
        current: undefined,
        previous: undefined,
        next: undefined,
        title: undefined,
        caption: undefined
      }
    };
  }

  render() {
    const { className, photos, showPhotoTitles } = this.props;
    const { lightbox } = this.state;

    return (
      <div className={cx('photo-gallery', className)}>
        <div className="photo-gallery__photos">

          { photos.map((photo, index) => (
            <div key={index}
              className="photo-gallery__photo-item"
              onClick={this.openLightbox.bind(this, index)}
            >
              <div className="photo-gallery__photo-wrapper">
                <div
                  className="photo-gallery__photo"
                  style={{ backgroundImage: `url(${photo.thumb})` }}
                />
              </div>

              { showPhotoTitles &&
                <span className="photo-gallery__photo-title">{ photo.title }</span>
              }
            </div>
          ))}

        </div>

        { lightbox.open &&
          <Lightbox
            imageTitle={lightbox.title}
            imageCaption={lightbox.caption}
            mainSrc={lightbox.current.url}
            nextSrc={lightbox.next ? lightbox.next.url : null}
            prevSrc={lightbox.previous ? lightbox.previous.url : null}
            enableZoom={false}
            onCloseRequest={this.closeLightbox.bind(this)}
            onMovePrevRequest={this.previousPhoto.bind(this)}
            onMoveNextRequest={this.nextPhoto.bind(this)}
          />
        }
      </div>
    );
  }

  openLightbox(index) {
    this.setLightboxPhoto(index);
  }

  nextPhoto() {
    this.setLightboxPhoto(this.state.lightbox.index + 1);
  }

  previousPhoto() {
    this.setLightboxPhoto(this.state.lightbox.index - 1);
  }

  closeLightbox() {
    this.setState({
      lightbox: {
        open: false,
        index: null,
        current: null,
        previous: null,
        next: null,
        title: null,
        caption: null
      }
    });
  }

  setLightboxPhoto(index) {
    const { photos, showPhotoTitles } = this.props;

    this.setState({
      lightbox: {
        open: true,
        index: index,
        current: photos[index],
        previous: (index > 0) ? photos[index - 1] : null,
        next: (index < photos.length - 1) ? photos[index + 1] : null,
        title: showPhotoTitles ? photos[index].title : null,
        caption: `${index + 1} of ${photos.length}`
      }
    });
  }
}

PhotoGallery.defaultProps = {
  className: '',
  showPhotoTitles: true
};

PhotoGallery.propTypes = {
  className: PropTypes.string,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      thumb: PropTypes.string
    })
  ),
  showPhotoTitles: PropTypes.bool
};

export default PhotoGallery;
